import React from 'react';

export default function BudgetMonitoring() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Budget Monitoring</h1>
      <p className="text-gray-500">Halaman Budget Monitoring</p>
    </div>
  );
}
